import { useEffect, useState } from 'react'
import { type TimeOfDay, parseTimeOfDay, timeOfDayFromHour } from '../lib/time-of-day'

/**
 * SSR では initial（サーバーの推定）で描き、クライアントで閲覧者の現地時刻に合わせ直す。
 * `?tod=night` などで上書きできる（QA とスクリーンショット用）。
 */
export function useTimeOfDay(initial: TimeOfDay, override?: string): TimeOfDay {
  const forced = parseTimeOfDay(override)
  const [tod, setTod] = useState<TimeOfDay>(forced ?? initial)
  useEffect(() => {
    if (forced) {
      setTod(forced)
      return
    }
    const update = () => setTod(timeOfDayFromHour(new Date().getHours()))
    update()
    const id = window.setInterval(update, 60_000)
    return () => window.clearInterval(id)
  }, [forced])
  return tod
}
